import React from 'react';
import { Contract } from '../../../types/contract';
import { mainCategoryInfo } from '../../../mocks/contracts';

interface ContractCardProps {
  contract: Contract;
  onPreview: () => void;
}

const ContractCard: React.FC<ContractCardProps> = ({ contract, onPreview }) => {
  const categoryData = mainCategoryInfo[contract.category as keyof typeof mainCategoryInfo];

  return (
    <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group">
      <div className="relative h-64 bg-gray-100 overflow-hidden cursor-pointer" onClick={onPreview}>
        <img 
          src={contract.previewImages[0]} 
          alt={contract.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300"></div>
        <div 
          className="absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-bold text-white"
          style={{ backgroundColor: categoryData.color }}
        >
          {categoryData.name}
        </div>
      </div>

      <div className="p-6">
        <h3 className="font-bold text-gray-800 text-lg mb-2 line-clamp-2 min-h-[3.5rem]">
          {contract.name}
        </h3>
        
        <div className="flex items-center justify-between mb-4">
          <span className="text-2xl font-bold text-[#d4af37]">
            NT$ {contract.price.toLocaleString()}
          </span>
        </div>

        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSeuJbYdeBMzieGnfn99LWF0ouQomCUDRkdqm8LYURvnotL5AA/viewform?usp=header"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full h-14 bg-[#d4af37] text-white font-bold rounded-lg hover:bg-[#c49d2e] transition-colors duration-300 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
        >
          <i className="ri-file-list-3-line text-xl"></i>
          <span>前往訂購表單</span>
        </a>
      </div>
    </div>
  );
};

export default ContractCard;
